import { CORE, gateway } from '../../api';

export function buscarOcorrenciasGrupoElfa(idProcesso) {
  return gateway.get(`${CORE}/processos/${idProcesso}/grupo-elfa-ocorrencias`);
}

export function registrarOcorrenciaGrupoElfa(idProcesso, { codOcorrencia, complemento }) {
  const payload = {
    codOcorrencia,
    ...(complemento?.trim().length > 0 && { complemento: complemento.trim() }),
  };
  return gateway.post(`${CORE}/processos/${idProcesso}/grupo-elfa-ocorrencia`, payload);
}
